import React, { Component } from 'react';
import SideBar from '../common/layout/sidebar.component.jsx';
import IntegrationEditForm from "./form/edit.component.jsx";
import Integrations from "./Integrations.jsx";

class IntegrationNew extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            integrationKey: this.props.match.params.integrationKey || ''
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
    }

    render() {

        return (
            <div>
                <IntegrationEditForm type={this.state.integrationKey}
                    authConnect={ Integrations.isIntegrationAuthConnect( this.state.integrationKey ) }
                    location={this.props.location}
                />
            </div>
        );
    }
}

export default IntegrationNew


// WEBPACK FOOTER //
// ./src/integration/new.component.jsx